import { render } from "./historyCard.vue?vue&type=template&id=46637687&scoped=true"
import script from "./historyCard.vue?vue&type=script&lang=js"
export * from "./historyCard.vue?vue&type=script&lang=js"

import "./historyCard.vue?vue&type=style&index=0&id=46637687&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46637687"]])

export default __exports__